import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ProductPage from "@/pages/ProductPage";
import TradeIn from "@/pages/TradeIn";
import Track from "@/pages/Track";
import { CartProvider } from "@/lib/cart";
import { CartDrawer } from "@/components/site/CartDrawer";
import { CartUpsell } from "@/components/site/CartUpsell";
import { InterestDialog } from "@/components/site/InterestDialog";
import { installContactTracking, trackVisit } from "@/lib/analytics";

const SiteTracking = () => {
  const { pathname } = useLocation();
  const onAdmin = pathname.startsWith("/admin");
  useEffect(() => { if (!onAdmin) trackVisit(); }, [onAdmin]);
  useEffect(() => { return installContactTracking(); }, []);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
      <SiteTracking />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/produto/:id" element={<ProductPage />} />
        <Route path="/troca" element={<TradeIn />} />
        <Route path="/rastreio" element={<Track />} />
        <Route path="/rastreio/:code" element={<Track />} />
      </Routes>
      <CartDrawer />
      <CartUpsell />
      <InterestDialog />
      <Toaster theme="dark" position="top-center" richColors />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
